function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useContext } from 'react';
import styles from './Stepper.module.scss';
import cs from 'classnames';
import { Link } from 'react-router-dom';
import { StepCountContext } from './Stepper';
import I18n from '../I18n/I18n/I18n';

// https://codepen.io/wmamattis/pen/ExNgjBV

export default function (_ref) {
  var children = _ref.children,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? '' : _ref$status,
    onClick = _ref.onClick,
    state = _ref.state,
    to = _ref.to;
  var steps = useContext(StepCountContext);
  var Component = !onClick && !to ? 'div' : Link;
  var handleClick = useCallback(function (e) {
    onClick && onClick(e);
    if (!to) {
      e.preventDefault();
    }
  }, [onClick, to]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, {
    className: cs(styles.step, _defineProperty(_defineProperty({}, styles.completed, status === 'completed'), styles.current, status === 'current')),
    onClick: handleClick,
    state: state,
    to: to
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.ordinal
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, children), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, ",", /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.stepper.step"
  }), ' ', /*#__PURE__*/React.createElement("span", {
    className: styles.srOrdinal
  }), ' ', /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.stepper.of"
  }), " ", steps, ",", !!status && /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.stepper.".concat(status)
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.spacer
  }));
}